import React, { FC } from 'react'
import s from './CardProduct.module.scss'
import { IProduct } from '../../store/types'
import { truncateText } from '../../utils'
import { Link } from 'react-router-dom'
import { BACKEND_URL } from '../../api'

interface dataProps {
    data: IProduct
}

const CardProduct: FC<dataProps> = ({ data }) => {
    return (
        <Link to={`/products/${data.id}/${data.title}`} className={s.card}>
            {data.img && (
                <div className={s.imageWrapper}>
                    <img src={BACKEND_URL + data.img} alt={data.title} className={s.image} />
                </div>
            )}
            <div className={s.box_content}>
                <h2>{data.title}</h2>
                <p>{truncateText(data.description, 100)}</p>
            </div>
            <div className={s.btn}>
                <button>Узнать больше</button>
            </div>
        </Link>
    )
}

export default CardProduct

